import { __assign, __read, __spreadArray } from "tslib";
export var buildRouteTree = function (rawTree) {
    return (function loop(tree, path) {
        if (path === void 0) { path = []; }
        return Object.keys(tree)
            .map(function (key) { return [key, tree[key]]; })
            .reduce(function (acc, _a) {
            var _b, _c;
            var _d = __read(_a, 2), key = _d[0], value = _d[1];
            var xPath = __spreadArray(__spreadArray([], __read(path), false), [key], false);
            var routeData = getRouteData(xPath, key);
            if (value === null) {
                return __assign(__assign({}, acc), (_b = {}, _b[key] = routeData, _b));
            }
            return __assign(__assign({}, acc), (_c = {}, _c[key] = __assign(__assign({}, loop(value, xPath)), routeData), _c));
        }, {});
    })(rawTree);
};
var makeGetPath = function (path) { return function (queryParams) {
    var params = queryParams
        ? "?".concat(Object.entries(queryParams)
            .map(function (x) { return x.join("="); })
            .join("&"))
        : "";
    return "".concat(path).concat(params);
}; };
var getRouteData = function (xPath, key) { return ({
    getPath: makeGetPath("/".concat(xPath.join("/"))),
    getElementKey: function () { return key; }
}); };
//# sourceMappingURL=routeUtils.js.map